export enum TeltonikaTaskState {
    loading,
    success,
    failure,
    cancelled,
  }